import { getDate } from '../../utils/formatDate'
import styles from './Meta.module.scss'

export default function Meta({ data, vAlign, hAlign }) {
  const { publishedAt, times } = data

  // console.log('Meta data: ', data, vAlign, hAlign)

  const time = times.estimatedReadingTime + ' Minute Read'
  let d = getDate(publishedAt, 'long')

  let hTw = ''
  let vTw = ''

  if (hAlign === 'block') {
    hTw = 'flex-col'
  } else {
    hTw = `flex-row gap-2 ${styles.center}`
  }

  if (vAlign === 'left') {
    vTw = `justify-start ${styles.left}`
  } else {
    vTw = 'mx-auto justify-center'
  }

  return (
    <div className={`${styles.wrapper} ${hTw} ${vTw}`}>
      <div>
        <span>{d}</span>
      </div>
      <em>―</em>
      <div>
        <span>{time}</span>
      </div>
    </div>
  )
}
